import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { Colors } from "@theme/colors";
import Markdown from "@components/Markdown";

interface Props {
  title: string;
  sections: string[];
}

const TextBlock: FC<Props> = ({ title, sections }) => {
  return (
    <Stack mt={1} mb={1}>
      <Typography
        variant="body2"
        sx={{
          marginBottom: "8px",
          fontSize: "18px",
          lineHeight: "24px",
          fontWeight: "400",
          color: Colors.TextPrimary,
        }}
      >
        {title}
      </Typography>
      <>
        {sections.map((item, idx) => {
          return (
            <Typography
              variant="body1"
              component="span"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "300",
                color: Colors.TextDark,
                "& p": {
                  margin: "0",
                },
              }}
              key={`para-${idx}`}
            >
              <Markdown key={`para-${idx}`} content={item} />
            </Typography>
          );
        })}
      </>
    </Stack>
  );
};

export default TextBlock;
